import { Outlet, useLocation, useNavigate } from 'react-router';
import { AppShell, HomeIcon, SettingsIcon, type NavGroup } from '@platform/design-system';
import { DeletionBanner, NoticeBanners, RouterLink, useSession } from '@platform/app-kit';
import { PRODUCT_NAME } from './brand.ts';

/**
 * The signed-in shell of a personal account: the product's name where Sprocket shows a
 * workspace, one nav entry, and the account menu (appearance, sign out). A tenant of one has no
 * workspace switcher, no team and no invitations (ADR personal-tenants-sign-up-in-the-cell-pool).
 */
export function PersonalShell() {
  const { principal, signOut } = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  if (!principal) return null;

  const nav: NavGroup[] = [
    {
      id: 'core',
      items: [
        {
          id: 'home',
          label: 'Home',
          icon: <HomeIcon />,
          href: '/',
          active: location.pathname === '/',
        },
        {
          id: 'account',
          label: 'Account',
          icon: <SettingsIcon />,
          href: '/account',
          active: location.pathname === '/account',
        },
      ],
    },
  ];

  return (
    <AppShell
      brand={{ name: PRODUCT_NAME, homeHref: '/' }}
      nav={nav}
      bottomTabs={[]}
      appearance
      account={{
        name: principal.name,
        email: principal.email,
        items: [],
        onSignOut: () => {
          void signOut().then(() => navigate('/login', { replace: true }));
        },
      }}
      LinkComponent={RouterLink}
    >
      {/* What we tell the person about their account comes before the page itself. */}
      <NoticeBanners />
      <DeletionBanner subject="account" manageHref="/account" />
      <Outlet />
    </AppShell>
  );
}
